import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["clear"]

  connect() {
    this.update()
  }

  update() {
    const hasValue = Array.from(this.element.querySelectorAll("input, select")).some(el => el.value !== "")
    this.clearTarget.classList.toggle("hidden", !hasValue)
  }
}
